<template>
  <div class="analytics-total-count-report">
    <div class="level">
      <h3 class="level-left">Total count of reports</h3>
      <div class="level-right">
        <b-select name="year" v-model="year" @input="selectByYear()">
          <option
            v-for="(year, index) in yearList()"
            :value="year"
            :key="index"
          >
            {{ year }}
          </option>
        </b-select>
      </div>
    </div>

    <apexchart
      v-if="series.length > 0 && chartOptions"
      type="area"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import analyticsService from "@/services/AnalyticsService";
import utitlityMixin from "@/mixins/UtilityMixin";
// @group Analytics
export default {
  name: "AnalyticsView",
  mixins: [utitlityMixin],
  data() {
    return {
      year: this.currentYear(),
      switchCustomerId: null,
      analyticsService: new analyticsService(),
      series: [
        // {
        //   name: "Past",
        //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        // },
        // {
        //   name: "Upcoming",
        //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        // }
      ],
      chartOptions: {
        chart: {
          type: "line",
          height: 450,
          stacked: true,
          stroke: {
            curve: "straight"
          },
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        legend: {
          position: "top",
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          onItemClick: {
            toggleDataSeries: false
          }
        },
        series: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        xaxis: {
          type: "text",
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC"
          ],
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        colors: ["#008ffb", "#00d1b2"],
        fill: {
          colors: ["#008ffb", "#00d1b2"],
          opacity: 0.9
        }
      },
      initChartOptions: {
        chart: {
          type: "area",
          height: 450,
          stacked: true,
          stroke: {
            curve: "straight"
          },
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        legend: {
          position: "top",
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          onItemClick: {
            toggleDataSeries: false
          }
        },
        series: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        xaxis: {
          type: "text",
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC"
          ],
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        colors: ["#008ffb", "#00d1b2"],
        fill: {
          colors: ["#008ffb", "#00d1b2"],
          opacity: 0.9
        }
      },
      pastChartOptions: {
        chart: {
          type: "area",
          height: 450,
          stacked: true,
          stroke: {
            curve: "straight"
          },
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        legend: {
          position: "top",
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          onItemClick: {
            toggleDataSeries: false
          }
        },
        series: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        xaxis: {
          type: "text",
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC"
          ],
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        colors: ["#008ffb"],
        fill: {
          colors: "#008ffb",
          type: "gradient"
        }
      },
      advanceChartOptions: {
        chart: {
          type: "area",
          height: 450,
          stacked: true,
          stroke: {
            curve: "straight"
          },
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        legend: {
          position: "top",
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          onItemClick: {
            toggleDataSeries: false
          }
        },
        series: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        xaxis: {
          type: "text",
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC"
          ],
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) return this.y;
            }
          }
        },
        colors: ["#00d1b2"],
        fill: {
          colors: "#00d1b2",
          type: "gradient"
        }
      }
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.fetchReportsTotalCount(this.currentYear());
  },
  methods: {
    selectByYear() {
      this.fetchReportsTotalCount(this.year);
    },
    fetchReportsTotalCount(year) {
      this.series = [];
      this.analyticsService
        .getReportTrackerTotalCountReport(year, this.switchCustomerId)
        .subscribe(
          response => {
            if (this.year == this.currentYear()) {
              this.series = response;
              this.chartOptions = this.initChartOptions;
            } else if (this.year < this.currentYear()) {
              this.chartOptions = this.pastChartOptions;
              this.series = response.filter(function(obj) {
                return obj.name !== "Upcoming";
              });
            } else {
              this.series = response.filter(function(obj) {
                return obj.name !== "Past";
              });
              this.chartOptions = this.advanceChartOptions;
            }
          },
          error => {
            console.log("error loading data");
          }
        );
    }
  }
};
</script>
